import React, { Component } from 'react'
import { clearProposalInfoAction, fetchProposalInfoAction } from '../actions/proposalInfo.js'

import PropTypes from 'prop-types'
import ProposalTable from '../components/Proposal/ProposalTable.js'
import { connect } from 'react-redux'
import { fetchProposals } from '../actions/proposals.js'
import { fetchSessionsByProposal } from '../actions/sessions.js'
import { setActiveProposal } from '../actions/application.js'
import { setBreadCrumbs } from '../actions/breadcrumbs.js'

class ProposalsContainer extends Component {
  constructor(props) {
    super(props)
    this.onProposalSelected = this.onProposalSelected.bind(this)

    this.loadingProposals = false
  }

  componentDidUpdate() {
    this.loadProposals()
  }

  loadProposals() {
    if (this.props.user.token && !this.loadingProposals) {
      const { configuration, user } = this.props

      if (configuration && user && user.token !== null) {
        this.loadingProposals = true
      }
    }
  }

  onProposalSelected(proposal, title) {
    this.props.setActiveProposal(proposal, title)
    this.props.fetchSessionsByProposal(this.props.user, proposal)
    this.props.fetchProposalInfo(this.props.user, proposal)
  }

  render() {
    return (
      <div>
        <ProposalTable handleSelect={this.onProposalSelected} proposals={this.props.proposals} />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    proposals: state.proposals,
    configuration: state.configuration,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    fetchProposals: user => dispatch(fetchProposals(user)),
    fetchProposalInfo: (user, proposal) => dispatch(fetchProposalInfoAction(user, proposal)),
    setBreadCrumbs: breadCrumbs => dispatch(setBreadCrumbs(breadCrumbs)),
    setActiveProposal: (proposal, title) => dispatch(setActiveProposal(proposal, title)),
    fetchSessionsByProposal: (user, proposal) => dispatch(fetchSessionsByProposal(user, proposal)),
    clearProposalInfo: () => dispatch(clearProposalInfoAction()),
  }
}

ProposalsContainer.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
}

export default connect(mapStateToProps, mapDispatchToProps)(ProposalsContainer)
